import { AuthScreenShell } from '@/components/auth-screen-shell';
import { SignInForm } from '@/components/sign-in-form';
import { useLocalSearchParams } from 'expo-router';

export default function SignInScreen() {
  const { returnTo } = useLocalSearchParams<{ returnTo?: string | string[] }>();
  return (
    <AuthScreenShell>
      <SignInForm returnTo={returnTo} />
    </AuthScreenShell>
  );
}
